import { Button, MagellanPopup } from 'components/atoms';
import { useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PiWarning } from 'react-icons/pi';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface IPopupOverwritingContractItemsProps {
  name: string;
  onAdd: (actions: PopupActions) => void;
  loading?: boolean;
  trigger?: JSX.Element;
}

const PopupOverwritingContractItems = ({
  loading,
  name,
  onAdd,
  trigger,
}: IPopupOverwritingContractItemsProps) => {
  const { t } = useTranslation();
  const popupRef = useRef<PopupActions>(null);

  return (
    <Popup ref={popupRef} modal nested trigger={trigger}>
      <MagellanPopup>
        <MagellanPopup.Header className='justify-center'>
          <PiWarning />
          {t(`popup.header`)}
        </MagellanPopup.Header>
        <div className='flex flex-col opacity-55 max-w-96 text-center gap-4'>
          <p>
            <Trans
              i18nKey={'popup.overwriting-contract-items'}
              values={{ name: name }}
              components={{ strong: <strong /> }}
            />
          </p>
          <p>{t(`popup.question`)}</p>
        </div>
        <div className='flex gap-2 mt-4'>
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t(`popup.cancel`)} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.submit}
            onClick={() => onAdd && popupRef.current && onAdd(popupRef.current)}
            isLoading={loading}>
            <Button.Text text={t(`button.overwrite`)} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default PopupOverwritingContractItems;
